import React from "react";

function LandingProgramStudyLoadingSkeleton() {
  return (
    <>
      {[...Array(9)].map((_, index) => (
        <div key={index} className="overflow-hidden relative flex flex-col w-[230px] h-[230px] px-2 pt-2 pb-4 justify-end items-center gap-4 bg-white border rounded">
          {/* Image Skeleton */}
          <div className="w-[214px] h-[162px] rounded-tr-[48px] rounded-bl-[48px] rounded-tl rounded-br bg-gray-200 animate-pulse"></div>
          {/* Text (Subject) Skeleton */}
          <div className="z-10 w-3/4 h-6 mt-1 bg-gray-200 rounded animate-pulse"></div>
          {/* Background Number Skeleton */}
          {/* Using "00" with a very light gray to mimic the structural space of the number */}
          <p className="absolute text-gray-100 text-[100px] bottom-[-59px] left-0 select-none font-bold animate-pulse">
            0{index + 1}
          </p>
        </div>
      ))}
    </>
  );
}

export default LandingProgramStudyLoadingSkeleton;
